import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../config/firebase';
import { useAuth } from '../context/AuthContext';
import './Footer.css';

function Footer() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    await signOut(auth);
    window.scrollTo(0, 0);
    navigate('/');
  };

  return (
    <footer className="footer">
      <div className="footer-links">
        {currentUser ? (
          <button className="footer-btn" onClick={handleLogOut}>Log Out</button>
        ) : (
          <Link className="footer-btn" to="/SignIn">Sign In</Link>
        )}
        <a className="footer-link" href="mailto:unggrahame@gmail.com">Email Me!</a>
        <a className="footer-link" href="https://github.com/unggrahame" target="_blank" rel="noreferrer">GitHub</a>
      </div>
      <p className="footer-copy">&copy; {new Date().getFullYear()} Grahame Ung</p>
    </footer>
  );
}

export default Footer;
